import React from 'react';

interface HoneypotFieldProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * Für Menschen unsichtbares Feld. Formular-Bots füllen es reflexartig mit aus —
 * der Server verwirft solche Einsendungen dann stillschweigend.
 *
 * Bewusst nicht `display: none`: Manche Bots überspringen ausgeblendete Felder.
 * `aria-hidden` und `tabIndex={-1}` halten es aus Screenreadern und der
 * Tab-Reihenfolge heraus.
 */
const HoneypotField: React.FC<HoneypotFieldProps> = ({ value, onChange }) => (
  <div className="honeypot" aria-hidden="true">
    <label htmlFor="website-url">Bitte dieses Feld leer lassen</label>
    <input
      id="website-url"
      name="website"
      type="text"
      tabIndex={-1}
      autoComplete="off"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

export default HoneypotField;
